var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-wrap"},[_c('span',{staticClass:"grade"},[_c('img',{staticClass:"pre",attrs:{"src":require('@/assets/vip1/VIP-Arc-'+ _vm.$store.state.myLevel +'.png')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }